import { Contact } from 'src/app/client/journey/shared/models/deal-resources/contact.model';
import { ClientJourneyValidationMetadata } from 'src/app/client/journey/shared/validation/client-journey-validation-metadata';
import { ModelValidator } from 'src/app/client/journey/shared/validation/model-validator';
import {
  isStringNullOrEmpty,
  isEmail,
} from 'src/shared-utilities/string-helpers';

export enum ReferralContactValidationRules {
  EmailFormat = 'emailFormat',
}

export class ReferralContactValidator extends ModelValidator<
  Contact,
  ClientJourneyValidationMetadata
> {
  constructor(contact: Contact) {
    super(contact);

    let navigationMetadata = <ClientJourneyValidationMetadata>{
      blocksNavigation: false,
      showInMenu: false,
    };

    //email - format
    this.ruleFor(
      c => c.email,
      ReferralContactValidationRules.EmailFormat,
      navigationMetadata,
    )
      .when(
        c =>
          !isStringNullOrEmpty(c.firstName, true) ||
          !isStringNullOrEmpty(c.lastName, true) ||
          !isStringNullOrEmpty(c.email, true),
      )
      .must(email => {
        return isEmail(email);
      });
  }
}
